import ReactDOM from 'react-dom';
import serverVars from 'server-vars';
import { UIDProvider } from 'dibs-uid';
import { IntlProvider } from 'dibs-react-intl';
import QueryRenderer from 'relay-query-lookup-renderer';
import { DibsRelayRenderProps } from 'dibs-relay-network-layer';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { trackPageview } from 'dibs-tracking';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import popularSearchesSitemapRootQuery from '../queries/popularSearchesSitemapRootQuery';
import { PopularSearchesSitemapLayout } from '../popularSearchesSitemap/components/PopularSearchesSitemapLayout';
import type {
    popularSearchesSitemapRootQuery as popularSearchesSitemapRootQueryType,
    popularSearchesSitemapRootQueryResponse,
} from '../queries/__generated__/popularSearchesSitemapRootQuery.graphql';

type ViewerType = NonNullable<NonNullable<popularSearchesSitemapRootQueryResponse>['viewer']>;

const relayVariables = serverVars.get('relayVariables');
const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

initializeDBL().then(() => {
    ReactDOM.hydrate(
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <UIDProvider>
                <QueryRenderer<popularSearchesSitemapRootQueryType>
                    lookup
                    environment={environment}
                    query={popularSearchesSitemapRootQuery}
                    variables={relayVariables}
                    render={({
                        props,
                    }: DibsRelayRenderProps<popularSearchesSitemapRootQueryType>) => (
                        <PopularSearchesSitemapLayout
                            viewer={props?.viewer as ViewerType}
                            relayVariables={relayVariables}
                        />
                    )}
                />
            </UIDProvider>
        </IntlProvider>,
        document.getElementById('js-root')
    );
    trackPageview({
        additional: {
            pageType: 'Results',
            pageSubType: 'Popular Searches',
        },
    });
});
